export class BaseDataReport {
	id: string;
	updatedAt: string;
	updatedByUser: string;
	from: string;
	to: string;
}
export class CashSummaryReport extends BaseDataReport {
	paymentTypeSummary: CashSummary[];
	totalChecks: number;
	total: number;
}

export class OpenSalesReport extends BaseDataReport {
	datas: OpenSales[];
	totalNoOfChecks: number;
	total: number;
}

export class AnalysisMenuItemReport extends BaseDataReport {
	reportKey: string;
	generatedAt: string;
	state: string;
	ping: ReportPing;
	data: FullDataAnalysisMenuItem;
	summary: TotalSummaryAnalysisMenuItem;
}

export class FullDataAnalysisMenuItem {
	totalItems: number;
	totalPages: number;
	pageSize: number;
	pageNum: number;
	data: AnalysisMenuItem[];
}

export class TotalSummaryAnalysisMenuItem {
	totalQuantity: number;
	totalTotalSales: number;
	totalAverage: number;
}

export class DetailSaleSummaryReport extends BaseDataReport {
	reportKey: string;
	generatedAt: string;
	state: string;
	ping: ReportPing;
	data: FullDataDetailSaleSummary;
	summary: TotalDetailSaleSummary;
}

export enum ReportState {
	Inprogress = "Inprogress",
	FileInprogress = "FileInprogress",
	Finished = "Finished",
}


export class FullDataTicketDetail {
	totalItems: number;
	totalPages: number;
	pageSize: number;
	pageNum: number;
	data: DetailSaleSummary[];
}

export class FullDataDetailSaleSummary {
	totalItems: number;
	totalPages: number;
	pageSize: number;
	pageNum: number;
	data: DetailSaleSummary[];
}
export class ReportPing {
	action: string;
	controller: string;
	method: string;
	routeData: ReportRouteData;
}

export class ReportRouteData {
	endDate: string;
	endTime: string;
	pageNum: number;
	pageSize: number;
	regenerate: false;
	startDate: string;
	startTime: string;
}
export class SalesSummaryReport extends BaseDataReport {
	paid: number;
	onCredit: number;
	totalBeforeTax: number;
	totalTax: number;
	totalAfterTax: number;
	numberOfTickets: number;
	numberOfGuests: number;
	avgPerTicket: number;
	avgPerGuest: number;
	amountDiscountNumber: number;
	totalAmountDiscount: number;
	totalPercentDiscount: number;
	totalDiscount: number;
	ticketType: string;
}
export class CashSummary {
	paymentType: string;
	paymentTypeDisplay: string;
	numberOfChecks: number;
	totalAmount: number;
}

export class OpenSales {
	paymentType: string;
	noOfChecks: number;
	total: number;
}

export class AnalysisMenuItem {
	menuItemNameVn: string;
	menuItemNameCn: string;
	menuItemNameEn: string;
	reportingGroup: string;
	quantity: string;
	totalSales: string;
	averagePrice: string;
}

export class DetailSaleSummary {
	ticketId: number;
	displayId: string;
	date: string;
	check: number;
	kitchen: number;
	bbq: number;
	dimsum: number;
	bar: number;
	pickle: number;
	cigarette: number;
	serviceFee: number;
	deliveryFee: number;
	totalBeforeTax: number;
	totalAfterTax: number;
	discountBefore: number;
	discountBeforeName: string;
	discountAfter: number;
	discountAfterName: string;
	tax: number;
	roundAdjusted: number;
	receiptTotal: number;
	paymentType: string;
	paymentTypeDisplay: string;
}
export class TotalDetailSaleSummary {
	totalKitchen: number;
	totalBBQ: number;
	totalDimsum: number;
	totalBar: number;
	totalPickle: number;
	totalCigarette: number;
	totalServiceFee: number;
	totalDeliveryFee: number;
	totalBeforeTax: number;
	totalDiscount: number;
	totalTax: number;
	totalRoundAdjusted: number;
	totalReceiptTotal: number;
}

export class ItemReport extends BaseDataReport {
	data: Items[];
	pageNum: number;
	pageSize: number;
	totalItems: number;
}

export class Items {
	nameEn: string;
	nameVi: string;
	nameCn: string;
	price: number;
	totalQuantity: number;
	totalDiscount: number;
	totalAmount: number;
	ticketItemId: number;
	TicketItemCreateAt: string;
}
